import React from 'react'
import PropTypes from 'prop-types'
import OffsetToTime from '../sitewide/OffsetToTime'
import OffsetToWeeksTime from '../sitewide/OffsetToWeeksTime'
import { SettingTypes } from '../../state/constants.js'
import styles from './styles/EditorHeader.js'

const EditorHeader = ({ setting, offset, isNegative, isWeeks }) => {
  const { message_setting_type, message_type } = setting
  const msgType_toUpper = message_type.charAt(0).toUpperCase() + message_type.slice(1)
  const timeFrame = isWeeks ? OffsetToWeeksTime[offset] :
    isNegative ? OffsetToTime[offset * -1] : OffsetToTime[offset]
  const beforeAfter = isNegative ? 'before' : 'after'
  const settingTypeText = SettingTypes[message_setting_type]

  let header
  if (timeFrame === undefined) {
    header = (
      <div className="EditorHeader">
        <span style={styles.blank_description}>
          {`Drag ${msgType_toUpper} Icon Left or Right to Select a Time`}
        </span>
        <br />
      </div>
    )
  } else {
    header = (
      <div className="EditorHeader">
        <span style={styles.description}>
          {`${msgType_toUpper} Reminder: `}
        </span>
        <span style={styles.offset}>
          {timeFrame}
        </span>
        <span style={styles.subdescription}>
          {` ${beforeAfter} ${settingTypeText}`}
        </span>
      </div>
    )
  }

  return header
}

EditorHeader.propTypes = {
  isNegative: PropTypes.bool.isRequired,
  isWeeks: PropTypes.bool.isRequired,
}

export default EditorHeader



// WEBPACK FOOTER //
// ./src/components/Settings/EditorHeader.js